module.exports = __webpack_public_path__ + "static/media/snooker-ball.8886677b.png";